module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-39-f5d8b1c9877a682200887c5331168e5d.svg";